module.exports = __webpack_public_path__ + "images/customer-management/milestones-example.png";